var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-default',[_vm._v(" Redirecionando... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }